import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FilesDropDirective } from '@core/directives/files-drop.directive';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { BrowseFileDirective } from '@core/directives/browse-file.directive';
import { ShipmentStore } from '@root/app/store/shipment_store';
import { UploadingStatus } from '@core/models/shipment.model';
import { FilledButtonComponent, TextButtonComponent } from '@custom-components/general/button';

@Component({
  selector: 'xemex-upload-shipment-file-dialog',
  imports: [
    MatIconModule,
    MatButtonModule,
    FilesDropDirective,
    BrowseFileDirective,
    MatProgressBarModule,
    TranslateModule,
    FilledButtonComponent,
    TextButtonComponent,
  ],
  standalone: true,
  providers: [ShipmentStore],
  templateUrl: './upload-shipment-file-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './upload-shipment-file-dialog.component.scss',
})
export class UploadShipmentFileDialogComponent {
  readonly shipmentStore = inject(ShipmentStore);
  readonly dialogRef = inject(MatDialogRef<UploadShipmentFileDialogComponent>);
  acceptedTypes = ['.csv'];
  UploadingStatus = UploadingStatus;

  onFileDrop(files: File[]) {
    this.shipmentStore.uploadShipmentsMethod(files);
  }

  onFileSelected(files: File[]) {
    const filesArray = Array.from(files);
    this.shipmentStore.uploadShipmentsMethod(filesArray);
  }

  onCancelUpload(index: number) {
    this.shipmentStore.cancelShipmentUploadingMethod(index);
  }

  onRefreshUpload(index: number) {
    this.shipmentStore.refreshShipmentUploadingMethod(index);
  }
}
